<template>
  <section class="fact">
    <div class="fact__header">
      <h2 class="wd-title">Solicita tu facturación</h2>
      <p class="wd-body">
        Para generar tu factura, envia a atencionaclientes@hircasa.com.mx<br>
        <span class="fact__hl">recuerda escribirnos del correo registrado al momento de tu contratación</span>
      </p>
    </div>

    <div class="fact__cards">
      <article v-for="item in items" :key="item.title" class="wd-card fact__card">
        <img :src="item.icon" alt="" aria-hidden="true">
        <p class="fact__text">{{ item.title }}</p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import factIdentificacion from '../../../assets/bienvenida-desktop/fact-identificacion.svg'
import factConstancia from '../../../assets/bienvenida-desktop/fact-constancia.svg'
import factFormato from '../../../assets/bienvenida-desktop/fact-formato.svg'

const items = [
  { title: 'Identificación oficial', icon: factIdentificacion },
  { title: 'Constancia fiscal', icon: factConstancia },
  { title: 'formato de alta de factura', icon: factFormato },
]
</script>

<style scoped>
.fact { display: flex; flex-direction: column; gap: var(--ds-space-7); }
.fact__header { display: flex; flex-direction: column; gap: var(--ds-space-4); }
.fact__hl { color: var(--ds-purple-400); }
.fact__cards { display: flex; gap: var(--ds-space-5); }
.fact__card {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: var(--ds-space-4);
  min-height: 72px;
  padding: var(--ds-space-4) var(--ds-space-3);
  border-radius: 8px;
}
.fact__card img { flex: 0 0 40px; width: 40px; height: 40px; }
.fact__text {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 14px;
  line-height: 20px;
}

@media (max-width: 1024px) {
  .fact__cards { gap: var(--ds-space-3); }
}

@media (max-width: 599px) {
  .fact { gap: var(--ds-space-6); }
  .fact__cards { flex-direction: column; gap: var(--ds-space-6); }
  .fact__card { flex: none; padding: var(--ds-space-4); }
  .fact__text { font-size: 16px; line-height: 24px; }
}
</style>
